/**
 * The permissions the company management view uses (SC-439): its tabs, header buttons and the
 * invite link. Anyone holding at least one opens the management view; everyone else gets the
 * read-only company view. Read from the shared surface list so a new tab can't be left out.
 */
import { RBAC_SURFACES } from '../../../../../types/rbac/surfaces'
import type { PermissionKey } from '../../../../../types/rbac/catalogue'

const MANAGER_VIEW_SURFACE = /^(manager-view\.|roles-permissions\.|workspace-invite-link\.)/

export const MANAGER_VIEW_KEYS: readonly PermissionKey[] = [
  ...new Set(RBAC_SURFACES.filter((s) => MANAGER_VIEW_SURFACE.test(s.id)).map((s) => s.requires)),
]
